import React, { useState, useEffect } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";


const getAttributesFromProducts = (products) => {
  const attrNamesList = products
    .filter((p) => p.attributes)
    .reduce((names, p) => [...names, ...Object.keys(p.attributes)], []);
  const attrNames = [...new Set(attrNamesList)];

  const attrs = attrNames.reduce((attr, name) => {
    if (!attr[name]) attr[name] = [];
    products
      .filter((p) => p.attributes)
      .forEach((p) => attr[name].push(p.attributes[name]));
    attr[name] = [...new Set(attr[name])];
    return attr;
  }, {});

  return attrs;
};

const productAttributesEqual = (product, attrs) => {
  let isEqual = true;
  Object.entries(attrs).forEach(([name, val]) => {
    if (!val) {
      return;
    }
    if (product?.attributes[name] !== val) {
      isEqual = false;
    }
  });
  return isEqual;
};

export const Variations = ({ selectedProduct, products, onChange }) => {
  const variations = selectedProduct?.parentId
    ? products?.filter((child) => child.parentId === selectedProduct?.parentId)
    : products?.filter((child) => child.parentId === selectedProduct?.id);
  const attributes = getAttributesFromProducts(variations);

  const initialState = {};
  Object.keys(attributes).forEach((name) => (initialState[name] = ""));

  const [selected, setSelected] = useState(initialState);

  const { id } = selectedProduct;
  useEffect(() => {
    setSelected(initialState);
  }, [id]);

  useEffect(() => {
    const allSelected =
      Object.values(selected).filter((val) => !val).length === 0;
    if (allSelected) {
      const selectedVariation = variations.filter((v) => {
        return productAttributesEqual(v, selected);
      });
      onChange(selectedVariation[0]);
    } else {
      const defaultVariationId = selectedProduct?.defaultVariationId;
      if (defaultVariationId) {
        const defaultVariation = products?.find(
          (p) => p.id === defaultVariationId
        );
        if (defaultVariation) {
          onChange(defaultVariation);
          setSelected(defaultVariation.attributes);
          return;
        }
      }
      onChange();
    }
  }, [selected]);

  if (!selectedProduct || !variations.length) {
    return null;
  }

  return (
    <div style={{ width: "100%", marginBottom: 10 }}>
      {Object.keys(attributes).map((name) => {
        const filteredVariations = variations.filter((v) => {
          return productAttributesEqual(v, { ...selected, ...{ [name]: "" } });
        });
        const filteredAttributes = getAttributesFromProducts(
          filteredVariations
        );
        const items = filteredAttributes[name];

        return (
          <FormControl style={{ width: "100%", marginBottom: 5 }}>
            <InputLabel>{name}</InputLabel>
            <Select
              value={selected[name]}
              onChange={(e) => {
                selected[name] = e.target.value;
                setSelected({ ...selected });
              }}
            >
              <MenuItem value="">Not selected</MenuItem>
              {items?.map((value) => {
                return <MenuItem value={value}>{value}</MenuItem>;
              })}
            </Select>
          </FormControl>
        );
      })}
    </div>
  );
};
